export default "__VITE_ASSET__CBL0vOKW__"